import HeadSetter from './head-setter';


export default HeadSetter;
